import React from "react";
import { useNavigate } from "react-router-dom";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <section className="container py-5">
      <div className="p-4 bg-light rounded shadow-sm">
        <h3 className="fw-bold text-primary mb-4 text-center">
          TERMS & CONDITIONS – WORKFORCE ENGAGEMENT
        </h3>

        {/* Fee Structure */}
        <h5 className="fw-bold mb-2">Fee Structure and Payment Terms</h5>
        <p>Our service fee for recruitment support is structured as follows:</p>

        <div className="ms-3">
          <p>👉 For Annual CTC up to Rs. 5 Lakhs – <b>7% of Annual CTC</b></p>
          <p>👉 For Annual CTC from Rs. 5.01 Lakhs to Rs. 10 Lakhs – <b>9% of Annual CTC</b></p>
          <p>👉 For Annual CTC above Rs. 10 Lakhs – <b>11% of Annual CTC</b></p>
        </div>

        <p>
          <b>CTC (Cost to Company)</b> includes fixed + variable pay and represents
          the total cost of employment.
        </p>

        {/* Confidentiality */}
        <h5 className="fw-bold mt-4 mb-2">Confidentiality</h5>
        <p>
          All information shared during the hiring or service engagement process
          will be treated with strict confidentiality by Amazon IT Solutions. We
          expect the same level of confidentiality from our clients.
        </p>

        {/* Invoice & Payment */}
        <h5 className="fw-bold mt-4 mb-2">Invoice & Payment</h5>
        <p>
          An invoice will be raised on the candidate’s joining date. Payment
          should be made within 10 to 15 days from the invoice date, irrespective
          of the client’s internal processing cycles.
        </p>

        {/* Termination Clause */}
        <h5 className="fw-bold mt-4 mb-2">Termination Clause</h5>
        <p>
          Either party may terminate the service agreement with a 30-day prior
          written notice.
        </p>

        {/* Replacement Guarantee */}
        <h5 className="fw-bold mt-4 mb-2">Replacement Guarantee</h5>
        <p>
          If a candidate leaves within 90 days of joining, Amazon IT Solutions
          will provide one-time <b>Free Replacement</b>.
        </p>

        {/* Closing Note */}
        <h5 className="fw-bold mt-4 mb-2">Thank you for considering Amazon IT Solutions</h5>
        <p>
          We look forward to supporting your organization with dependable IT
          services, workforce solutions, and business process support that help
          you grow and succeed in a fast-evolving digital world.
        </p>

        {/* Back button */}
        <div className="text-center">
          <button
            className="btn btn-warning mt-3 px-4"
            onClick={() => navigate(-1)}
          >
            ⬅ Back
          </button>
        </div>
      </div>
    </section>
  );
}